import { Api as WebAppApi } from './api/web-app';
import { injectInterceptors } from './interceptors';
import { eOneInstance } from './request';

// Note: `export *` instead of `export type *` for enum values
// export type * from './api/web-app';
export * from './api/web-app';
export * from './error';
export { errorCodeSetToBypass } from './interceptors';
export * from './request';

// ColumnType enum - matches backend C# enum ColumnType
// TODO: ADD_NEW_ADDITIONAL_COLUMN
export enum ColumnType {
  Calculation = 'calculation',
  CrmActivityParty = 'crmactivityparty',
  CrmColumnSet = 'crmcolumnset',
  CrmEntityLookup = 'crmentitylookup',
  CrmEntityReference = 'crmentityreference',
  CrmLabel = 'crmlabel',
  CrmListOptionLookup = 'crmlistoptionlookup',
  CrmLookup = 'crmlookup',
  CrmMappedColumnSet = 'crmmappedcolumnset',
  CrmMultiListOptionLookup = 'crmmultilistoptionlookup',
  CrmRelationship = 'crmrelationship',
  CrmRestMultiLookup = 'crmrestmultilookup',
  CustomRolling = 'customrolling',
  Datasource = 'datasource',
  Date = 'date',
  FinOpsLookup = 'finopslookup',
  GenericRestLookup = 'genericrestlookup',
  GlobalRolling = 'globalrolling',
  List = 'list',
  LocalConstant = 'localconstant',
  NavOdataApiLookup = 'navodataapilookup',
  NavOdataFieldLookup = 'navodatafieldlookup',
  MssqlLookup = 'mssqllookup',
  NavPageFieldLookup = 'navpagefieldlookup',
  NavPageKeyLookup = 'navpagekeylookup',
  NetSuiteCustomList = 'netsuitecustomlist',
  NetSuiteLookup = 'netsuitelookup',
  NetSuiteMultiLookup = 'netsuitemultilookup',
  NetSuiteRestletLookup = 'netsuiterestletlookup',
  NetSuiteRestLookup = 'netsuiterestlookup',
  NetSuiteRestListOption = 'netsuiterestlistoption',
  NetSuiteRestRecordReference = 'netsuiterestrecordreference',
  NetSuiteSuiteQLLookup = 'netsuitesuiteqllookup',
  ParentDatasource = 'parentdatasource',
  PostgreLookup = 'postgrelookup',
  SalesForceLookup = 'salesforcelookup',
  Translation = 'translation',
}

// NoDataRunTasksOption enum - matches backend C# enum NoDataRunTasksOption
export enum NoDataRunTasksOption {
  RunAll = 'RunAll',
  RunFailure = 'RunFailure',
  RunSuccess = 'RunSuccess',
  RunNone = 'RunNone',
}

// DataSourceExclusions enum - matches backend C# enum DataSourceExclusions
export enum DataSourceExclusions {
  DoNothing = 'DoNothing',
  ExcludeBlankLines = 'ExcludeBlankLines',
  ExcludeBlankKeys = 'ExcludeBlankKeys',
}

// ScriptOptions enum - matches backend C# enum ScriptOptions
export enum ScriptOptions {
  CSharp = 'CSharp',
  VisualBasic = 'VisualBasic',
  JavaScript = 'JavaScript',
}

const webAppApi = new WebAppApi({
  baseURL: '/',
});

const webAppApiInstance = webAppApi.instance;

injectInterceptors(eOneInstance);
injectInterceptors(webAppApi.instance);

export { webAppApi, webAppApiInstance };
